
import React from "react";
import { Loader2 } from "lucide-react";

interface ChangelogTabProps {
  changelogs: any[];
  isLoadingChangelogs: boolean;
}

const ChangelogTab = ({ changelogs, isLoadingChangelogs }: ChangelogTabProps) => {
  return (
    <>
      <div className="px-5 py-4 bg-gradient-to-b from-muted/20 to-background border-b sticky top-0 z-10">
        <h2 className="text-lg font-semibold">Latest Updates</h2>
        <p className="text-xs text-muted-foreground mt-0.5">Stay informed about our latest changes</p>
      </div>
      <div className="p-5">
        {isLoadingChangelogs ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <div className="space-y-4 pb-4">
            {changelogs.map(log => (
              <div key={log.id} className="p-4 border rounded-xl bg-gradient-to-br from-muted/20 to-background hover:from-muted/30 transition-colors">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="font-semibold text-base">{log.title}</h3>
                  <span className="text-xs text-muted-foreground whitespace-nowrap bg-muted px-2 py-1 rounded-md">
                    {new Date(log.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </span>
                </div>
                <div
                  className="text-sm text-muted-foreground prose prose-sm max-w-none prose-headings:text-sm prose-p:text-sm prose-p:leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: log.description }}
                />
              </div>
            ))}
            {changelogs.length === 0 && (
              <div className="text-center text-muted-foreground py-12 bg-muted/20 rounded-xl">
                <p className="text-sm">No updates available</p>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ChangelogTab;
